import {useEffect} from "react";

export const usePlaylistSetup = (playlist, player) => {
    useEffect(() => {
        if ( !playlist || ! player) {
            // console.warn('no player')
            return;
        }
        if ( ! player.playlist ) {
            // console.error('no playlist plugin');
            return;
        }
        console.log("playlist:", playlist);
        player.playlist(playlist);
        player.playlistUi({horizontal: true});
        player.playlist.autoadvance(0);
    }, [playlist, player]);

}
